import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import AdminLayout from "../../layout/adminLayout";
import { environment, apiRoutes } from "../../auth/apiRoute";
import Axios from "axios";
import {
  Pagination,
  Table,
  Tag,
  Space,
  message,
  notification,
  Popconfirm,
  Button,
  Divider,
  Input,
  Spin,
  Form,
  Select,
  Typography,
  Switch,
  Checkbox,
} from "antd";
import { CloseOutlined, CloseCircleTwoTone } from "@ant-design/icons";
export default function Hotels() {
  useEffect(() => {
    setLoading(true);

    getHotels();
    // getQueryAndSetFilter();
    setLoading(false);
  }, []);
  const { Text } = Typography;
  const { Search } = Input;
  const { Option } = Select;

  const [loading, setLoading] = useState(false);
  const [hotels, setHotels] = useState([]);

  const [filteredHotels, setFilteredHotels] = useState([]);
  const [filteredInfo, setFilter] = useState({});
  const [search, setSearch] = useSearchParams();

  const tagColors = ["gold", "lime", "green", "cyan", "blue", "geekblue"];
  const getHotels = async () => {
    try {
      const response = await Axios.post(apiRoutes["admin/hotels"]);

      if (response.status == 200) {
        var hotelsData = response.data;
        console.log(hotelsData);
        hotelsData = hotelsData.map((item) => {
          return { ...item, ...{ key: item._id } };
        });
        setHotels(hotelsData);
        setFilteredHotels(hotelsData);
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
  };
  const updateHotel = async (values) => {
    // filteredHotels.forEach((item) => {
    //   if (item._id == values._id) {
    //     delete values.admin;
    //     item = values;
    //   }
    // });
    // setFilteredHotels([...filteredHotels]);

    // return;
    try {
      const response = await Axios.post(
        apiRoutes["admin/hotel/update"],
        values
      );
      console.log(response);
      if (response.status == 200) {
        var newHotel = response.data;
        console.log(newHotel);
        newHotel.key = newHotel._id;
        var newHotels = filteredHotels.map((item) => {
          if (item._id == newHotel._id) {
            return newHotel;
          }
          return item;
        });
        setFilteredHotels([...newHotels]);
      }
    } catch (error) {
      message.error(error.response.data.message);
    }
  };
  const onChange = (e) => {
    const value = e.target.value.toLowerCase();
    console.log(value);
    if (!value) {
      setFilteredHotels(hotels);
    } else if (value.length > 4) {
      var filters = hotels.filter((item) => {
        let keys = Object.keys(item);
        var bool = false;

        keys.forEach((key) => {
          if (key != "_id" && key != "key") {
            if (typeof item[key] === "string" && item[key]) {
              if (item[key].toLowerCase().includes(value)) {
                bool = true;

                return;
              }
            }
          }
        });
        return bool;
      });
      console.log(filters);
      setFilteredHotels([...filters]);
    }
  };

  const onSearch = (value) => {
    if (!value) {
      setFilteredHotels(hotels);
    } else if (value.length > 2) {
      var filters = hotels.filter((item) => {
        let keys = Object.keys(item);
        var bool = false;

        keys.forEach((key) => {
          if (key != "_id" && key != "key") {
            if (typeof item[key] === "string" && item[key]) {
              if (item[key].toLowerCase().includes(value)) {
                bool = true;

                return;
              }
            }
          }
        });
        return bool;
      });
      console.log(filters);
      setFilteredHotels([...filters]);
    }
  };

  const clearFilters = () => {
    setFilter({ filteredInfo: null });
    setSearch("");
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      // filteredValue: filteredInfo.firstName || null,
      // sorter: (a, b) => a.hotel.name.localeCompare(b.hotel.name),

      render: (text, record) => {
        return record.name;
      },
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "street",
      render: (text, record) => {
        return `${record.street}, ${record.city}, ${record.state}, ${record.zip}`;
      },
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, record) => {
        return (
          <Switch
            checkedChildren="Active"
            unCheckedChildren="Suspended"
            onClick={async () => {
              record.suspended = !record.suspended;
              record.action = "suspend";
              await updateHotel(record);
            }}
            checked={!record.suspended}
          />
        );
      },
    },
    {
      title: "Main Contact",
      dataIndex: "admin",
      key: "admin",
      render: (text, record) => {
        if (record.admin) {
          return (
            <>
              {record.admin.firstName} {record.admin.lastName}{" "}
              <a
                onClick={async () => {
                  var action = "removeAdmin";
                  record.action = action;
                  const newHotel = await updateHotel(record);
                }}
              >
                <CloseCircleTwoTone />{" "}
              </a>
            </>
          );
        }
        return "";
      },
    },
  ];
  const testAdmin = () => {
    const hotel = filteredHotels.find(
      (item) => item._id == "625488972ac76821aa73a947"
    );
    console.log(hotel);

    if (hotel && hotel.admin) {
      return hotel.admin.firstName;
    }
    return "no";
  };
  return (
    <Spin spinning={loading}>
      <Search
        style={{ width: "50%" }}
        placeholder="Search ..."
        onSearch={onSearch}
        enterButton
        onChange={onChange}
      />
      <Button onClick={clearFilters}>Clear filters</Button>
      {testAdmin()}
      <Divider />
      <Table columns={columns} dataSource={filteredHotels} />
    </Spin>
  );
}
